import { SearchOutlined } from "@ant-design/icons";
import { AutoComplete, Button, Input, Table } from "antd";
import { useEffect, useState } from "react";


import moment from "moment";
import usePaymentStore from "stores/paymentStore";

const ReceiptsTable = ({
  receipts,

}) => {
  const payments = usePaymentStore((state) => state.payments);


  const [clientSearchValue, setClientSearchValue] = useState('');
  const [clientOptions, setClientOptions] = useState([]);



  useEffect(() => {
    // Get unique client names from receipts
    const uniqueClients = [...new Set(receipts
      .filter(receipt => receipt.client_name)
      .map(receipt => receipt.client_name))]
      .sort((a, b) => a.localeCompare(b));
    
    setClientOptions(uniqueClients.map(name => ({ value: name })));
  }, [receipts]);


  const columns = [
    {
      title: "Invoice No",
      dataIndex: "invoice_number",
      width: "6%",
      key: "6",
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => {
        return (
          <>
            <Input
              style={{ margin: "1rem", width: "25rem" }}
              autoFocus
              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target?.value ? [e.target.value] : []);
              }}
              onPressEnter={() => {
                confirm();
              }}
              onBlur={() => {
                confirm();
              }}
              placeholder="Search"
            ></Input>
            <Button
              style={{ margin: "1rem" }}
              type="primary"
              onClick={() => {
                confirm();
              }}
            >
              Search
            </Button>
            <Button
              style={{ marginRight: "1rem" }}
              onClick={() => {
                clearFilters({ confirm: true });
                setSelectedKeys("");
                confirm();
              }}
            >
              Reset
            </Button>
          </>
          
        );
      },

      filterIcon: () => {
        return <SearchOutlined />;
      },

      onFilter: (value, record) => {
        console.log({ record }, "record");

        return record?.invoice_number.toString()?.includes(value.toString());
      },
    },




    {
      title: "Date",

      render: (_, record) => moment(record.date).format("DD-MM-YYYY"),
      key: "3",
    },

{
      title: "Client",
      dataIndex: "client_name",
      key: "2",
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => {
        return (
          <>
            <AutoComplete
              style={{ margin: "1rem", width: "25rem" }}
              autoFocus
              value={selectedKeys[0] || clientSearchValue}
              options={clientOptions}
              onSearch={(value) => {
                const searchLower = value.toLowerCase();
                
                // Filter and sort clients by priority
                const filteredOptions = [...new Set(receipts
                  .filter(receipt => receipt.client_name)
                  .map(receipt => receipt.client_name))]
                  .map(name => {
                    const nameLower = name.toLowerCase();
                    let priority = -1;
                    
                    // Highest priority: Starts with search term
                    if (nameLower.startsWith(searchLower)) {
                      priority = 2;
                    }
                    // Second priority: Word starts with search term
                    else if (nameLower.split(' ').some(word => word.toLowerCase().startsWith(searchLower))) {
                      priority = 1;
                    }
                    // Lowest priority: Contains search term
                    else if (nameLower.includes(searchLower)) {
                      priority = 0;
                    }
                    
                    return { name, priority };
                  })
                  .filter(item => item.priority >= 0)
                  .sort((a, b) => {
                    // Sort by priority first
                    if (b.priority !== a.priority) {
                      return b.priority - a.priority;
                    }
                    // Then alphabetically
                    return a.name.localeCompare(b.name);
                  })
                  .map(item => ({ value: item.name }));

                setClientOptions(filteredOptions);
                setClientSearchValue(value);
                setSelectedKeys(value ? [value] : []);
              }}
              onSelect={(value) => {
                setClientSearchValue(value);
                setSelectedKeys([value]);
                confirm();
              }}
              onChange={(value) => {
                setClientSearchValue(value);
                setSelectedKeys(value ? [value] : []);
              }}
              placeholder="Search client"
            />
            <Button
              style={{ margin: "1rem" }}
              type="primary"
              onClick={() => {
                confirm();
              }}
            >
              Search
            </Button>
            <Button
              style={{ marginRight: "1rem" }}
              onClick={() => {
                clearFilters({ confirm: true });
                setClientSearchValue('');
                setSelectedKeys([]);
                // Reset client options to full list
                const uniqueClients = [...new Set(receipts
                  .filter(receipt => receipt.client_name)
                  .map(receipt => receipt.client_name))]
                  .sort((a, b) => a.localeCompare(b));
                setClientOptions(uniqueClients.map(name => ({ value: name })));
                confirm();
              }}
            >
              Reset
            </Button>
          </>
        );
      },
      filterIcon: () => {
        return <SearchOutlined />;
      },
      onFilter: (value, record) => {
        if (!value) return true;
        const clientName = record.client_name || '';
        return clientName.toLowerCase().includes(value.toLowerCase());
      },
    },

    {
      title: "Amount",

      render: (record) => {
        return (
          <>
            {record.amount.toFixed(2)}

        
          </>
        );
      },
      key: "2",
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => {
        return (
          <>
            <Input
              style={{ margin: "1rem", width: "25rem" }}
              autoFocus
              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target?.value ? [e.target.value] : []);
              }}
              onPressEnter={() => {
                confirm();
              }}
              onBlur={() => {
                confirm();
              }}
              placeholder="Search"
            ></Input>
            <Button
              style={{ margin: "1rem" }}
              type="primary"
              onClick={() => {
                confirm();
              }}
            >
              Search
            </Button>
            <Button
              style={{ marginRight: "1rem" }}
              onClick={() => {
                clearFilters({ confirm: true });
                setSelectedKeys("");
                confirm();
              }}
            >
              Reset
            </Button>
          </>
        );
      },
      filterIcon: () => {
        return <SearchOutlined />;
      },

      onFilter: (value, record) => {
        console.log({ record }, "record");

        return record?.amount.toString()?.includes(value.toString());
      },
    },

    {
      title: "Adjusted Amount",
      dataIndex: "adjusted_amount",
      key: "1",
      width: "20%",
    },

  

  
    
  ];

  return (
    <>
      <Table
        key={payments?._id}
        rowKey={"_id"}
        columns={columns}
        pagination={true}
        dataSource={receipts}
      />
    </>
  );
};

export default ReceiptsTable;
